import React from 'react';

const InputErrorMessage = (props) => {
    return (
        <p className='mb-3' style={{ color: '#FF4040' }}>
            {props.message}
        </p>
    );
};

export default InputErrorMessage;
